import { createLocaleController } from '@saas-pages/shared/public/i18n'
import { blogSlugFromPathname } from '@saas-pages/shared/public/i18n'
import { enTranslations } from './en'
import { DEFAULT_LOCALE, LOCALES, STORAGE_KEY, type Locale } from './locale'
import { ruTranslations, type Translations } from './ru'
import { getPostBySlug } from '@/shared/blog/posts'

export function resolvePathLocale(pathname: string): Locale | null {
  const slug = blogSlugFromPathname(pathname)
  return slug ? getPostBySlug(slug)?.locale ?? null : null
}

const controller = createLocaleController<Locale, Translations>({
  locales: LOCALES,
  defaultLocale: DEFAULT_LOCALE,
  storageKey: STORAGE_KEY,
  translations: {
    ru: ruTranslations,
    en: enTranslations,
  },
  numberLocales: {
    ru: 'ru-RU',
    en: 'en-US',
  },
  resolvePathLocale,
})

export const I18nProvider = controller.I18nProvider
export const useT = controller.useT
export const useLocale = controller.useLocale
export const localeCode = controller.numberLocale
